import React, { FC, ReactNode } from "react";

interface DlList {
  dt: ReactNode;
  dd: ReactNode;
  border?: boolean;
}

interface Props {
  title: string;
  list: DlList[];
}

const styles = {
  card: "rounded-[16px] border md:rounded-lg",
  cardHead:
    "flex justify-between items-center border-b px-4 pt-6 pb-5 md:py-[19px]",
  title: "text-[22px] md:text-xl font-bold",
  dl: "px-4 pb-6",
  dt: "pt-[22px] md:pt-6 font-bold first:pt-4",
  dtBorder: "pt-6 mt-5 mt:mt-6 border-t border-theme-light font-bold",
  dd: "mt-0.5 md:mt-1 break-words",
};

const DlItem: FC<DlList> = ({ dt, dd, border }) => {
  return (
    <>
      <dt className={border ? styles.dtBorder : styles.dt}>{dt}</dt>
      <dd className={styles.dd}>{dd}</dd>
    </>
  );
};

export const AccountsListCard: FC<Props> = ({ title, list }) => {
  const dlItems = list.map((item, index) => (
    <DlItem key={index} dt={item.dt} dd={item.dd} border={item.border} />
  ));
  return (
    <section className={styles.card}>
      <div className={styles.cardHead}>
        <h3 className={styles.title}>{title}</h3>
      </div>
      <dl className={styles.dl}>{dlItems}</dl>
    </section>
  );
};
